// NBL1_Player Pages
import rules from "../../Data/Rules"
import functions from "../../Data/Functions"
import settings from "../Settings/BIGV_Settings"
import Verification from "../Steps/Verification"
import Base_Details from "../Steps/BaseDetails"
import store from "../../veux/store"

let Countries, PlayingStatus, Associations, Clubs
let step2, step3


// BIGV Player Step Schema
const Load_BIGV_Player_Steps = () => {
    return {
        Portal: '2024 BIGV Player',
        // MainColor: "#0305a1",
        MainColor: "#f5924c",
        Logo: require(`../../assets/BigVLogoNewT.png`),
        Title: `<h2>Big V Player Registration Form</h2>`,
        Description: ``,
        Model: {},
        steps: [
            // Step 1
            {
                stepno: 1,
                title: 'Introduction',
                valid: true,
                nextBtn: "NO",
                backBtn: "NO",
                information: `<H2 style="text-align:center;">Welcome to Big V 2024!</H2>
                            </p>
                            With Round 1 commencing on <b>16th/17th March</b> we look forward to getting back 
                            on court and growing together as a league in 2024. With exciting new improvements to 
                            the league, we want to work more with YOU to develop the competition further and continue 
                            to make every game an event!
                            </p> 
                            <hr>
                            <br>
                            Before beginning your registration process, please take the time to read over the following:
                            <br><br>
                            <ul>
                            <li>Once a players registration to an Association for the Big V season has been approved 
                            by the league, the player and Association Delegate will receive email notification of approval</li>
                            <li>If any player is intending to play both Youth and Senior teams in 2024, please ensure 
                            you select both teams in the registration</li>
                            <li>If you are registering during the season, please submit your registration prior to 
                            <b>4pm Friday</b> for approval for those weekends round games</li>
                            <li>Players cannot register to play post the cut off period for finals qualification. 
                            See the link to find your division. 
                            <a href="https://admin.ownurgoal.net.au/_lib/file/doc/2024_Finals_Qualification_Requirements.pdf" target="_blank">2024 Big V Finals Qualification per Division</a></li>
                            <li>Any player who has registered and been assigned to a team of a NBL1 Association 
                            and/or equivalent highest level in the state in that same competition year may not register and 
                            transfer in the Big V 2024 season after the states season deadline of 11:59pm 26 May 2024 (End of Round 8).  </li>
                            </ul>
                            <br>
                            </p>
                            You must complete all mandatory fields. If you do not, then the submitted registration will not proceed.  
                            </p>
                            If you encounter any issues please contact Big V via email <a href="mailto:BigV@basketballvictoria.com.au">BigV@basketballvictoria.com.au</a> for assistance.`,
                Schema: {
                    continue: {
                        type: 'btn',
                        block: true,
                        rounded: true,
                        color: "orange",
                        label: 'Continue',
                        iconRight: 'check',
                        col: 12,
                        class: 'mx-0 px-10',
                        onClick: (val, home) => {
                            let { data, schema, obj } = val
                            home.next()
                        }
                    }
                },
            },
            // Step 2
            step2,
            // Step 3
            step3,
            //Step 4
            {
                stepno: 4,
                title: 'Rego',
                valid: true,
                information: '',
                Schema: {
                    PlayingStatus: {
                        OUG_id: "3373",
                        type: "select",
                        label: "Playing Status",
                        outlined: true,
                        dense: true,
                        // col: 12,
                        class: 'mx-1 px-1',
                        rules: [rules.requiredMsg('Playing Status is Required')],
                        items: PlayingStatus,
                        onInput: async (ev, portal) => {
                            if (ev.data.PlayingStatus == "Australian Citizen") {
                                ev.schema.birthCountry.hidden = true
                                ev.schema.birthCountry.rules = []
                                ev.schema.BAApproval.hidden = true
                                ev.schema.BAApproval.rules = []
                                ev.schema.Proof.hidden = store.getters.passport
                                ev.schema.Proof.rules = (store.getters.passport) ? [] : [rules.requiredMsg('Passport or Birth Certificate is Required')]
                                ev.schema.hasProof.hidden = !store.getters.passport
                            } else {
                                ev.schema.birthCountry.hidden = false
                                ev.schema.birthCountry.rules = [rules.requiredMsg('Country of Birth is Required')]
                                ev.schema.BAApproval.hidden = false
                                ev.schema.BAApproval.rules = [rules.requiredMsg('BA Approval Notice is Required')]
                                ev.schema.Proof.hidden = true
                                ev.schema.Proof.rules = []
                                ev.schema.hasProof.hidden = true
                            }
                        },
                        OUG: { Contact_Details: { Type: 3373, Action: "Unique" } },
                    },
                    Proof: {
                        type: 'file',
                        label: 'Please upload document proof of Australian Citizenship',
                        multiple: false,
                        outlined: true,
                        hidden: true,
                        dense: true,
                        accept: "image/*,application/pdf",
                        rules: [rules.fileSize()],
                        class: 'mx-1 px-1',
                        OUG: {
                            Contact_Details: {
                                Type: 1867,
                                Action: "SingleDesc",
                                Description: 'Passport or proof of Citizenship',
                            }
                        },
                    },
                    hasProof: {
                        type: 'text',
                        dense: true,
                        disabled: true,
                        hidden: true,
                        class: 'mx-1 px-1',
                        Startslot: `<H4 style="text-align:center;color:red">We have already sighted your Passport or proof of Citizenship</H4>`,
                    },
                    birthCountry: {
                        type: 'select',
                        label: 'Country of Birth?',
                        outlined: true,
                        dense: true,
                        hidden: true,
                        rules: [],
                        class: 'mx-1 px-1',
                        items: Countries,
                        value: '',
                        OUG: { Contact_Details: { Type: 3394, Action: "Unique" } },
                    },
                    BAApproval: {
                        type: 'file',
                        label: 'Please upload proof notice you have received approval from Basketball Australia for this competition year',
                        multiple: false,
                        accept: "image/*,application/pdf",
                        outlined: true,
                        dense: true,
                        hidden: true,
                        col: 12,
                        rules: [rules.fileSize()],
                        class: 'mx-1 px-1',
                        Startslot: `<i><b><p style="text-align:center;color:red">Please Note:</b> Any player playing in a senior elite division 
                                            who is NOT A CURRENT AUSTRALIAN CITIZEN  in addition to their registration 
                                            will require Basketball Australia approval for each competition year to be eligible</i>
                                            </br>
                                            <a href="https://admin.ownurgoal.net.au/_lib/file/OUGImages/626e43a3-1445-4478-b1a3-c9f6b078beb0.pdf" target="blank">Foreign Born Player (not a current Australian Citizen) approval process</a></p>`,
                        OUG: {
                            Contact_Details: {
                                Type: 1867,
                                Action: "SingleDesc",
                                Description: "BA Approval Notice",
                            }
                        },
                    },
                    Association: {
                        type: "select",
                        label: "Association?",
                        outlined: true,
                        dense: true,
                        rules: [rules.requiredMsg('Association is Required')],
                        class: 'mx-1 px-1',
                        items: Associations,
                        returnObject: true,
                        itemText: 'Detail',
                        onInput: async (ev, portal) => {
                            ev.schema.CompSelect.hidden = false
                            if (ev.data.Teams && ev.data.Teams.length > 0) {
                                ev.data.Teams.splice(0, ev.data.Teams.length)
                            }
                            Clubs = await settings.LookupTeams(
                                ev.data.Association.Code_id,
                                ev.data.CompSelect
                            )
                            if (ev.data.CompSelect) {
                                ev.schema.Teams.hidden = false
                                ev.schema.Teams.rules = [rules.requiredSelSingle]
                                ev.schema.Teams.items = Clubs
                            } else {
                                ev.schema.Teams.hidden = true
                                ev.schema.Teams.rules = []
                            }
                        }
                    },
                    CompSelect: {
                        "type": "select",
                        "label": "Competition Selection",
                        outlined: true,
                        dense: true,
                        hidden: true,
                        rules: [rules.requiredMsg('Competition Selection is Required')],
                        class: 'mx-1 px-1',
                        items: settings.CompType,
                        onInput: async (ev) => {
                            if (ev.data.Teams && ev.data.Teams.length > 0) {
                                ev.data.Teams.splice(0, ev.data.Teams.length)
                            }
                            Clubs = await settings.LookupTeams(
                                ev.data.Association.Code_id,
                                ev.data.CompSelect
                            )
                            if (ev.data.Association) {
                                ev.schema.Teams.hidden = false
                                ev.schema.Teams.rules = [rules.requiredSelSingle]
                                ev.schema.Teams.items = Clubs
                            } else {
                                ev.schema.Teams.hidden = true
                                ev.schema.Teams.rules = []
                            }

                            ev.schema.IndigNBL.hidden = true
                            ev.schema.IndigNBL.rules = []
                            // Check if Indigenious status
                            if (ev.data.Indigenous && (ev.data.Indigenous.includes("Aboriginal") ||
                                (ev.data.Indigenous.includes("Torres Strait")))) {

                                ev.schema.IndigNBL.hidden = false
                                ev.schema.IndigNBL.rules = [rules.requiredMsg('Share Contact Information is required')]
                                if (ev.obj.value == 'Female Competition') {
                                    ev.schema.IndigNBL.Startslot = `<p style="text-align:center;color:lightgreen;font-size:12px;">
                                        <b>Do you give permission for your contact information to be shared with the WNBL(BA) and Basketball Victoria 
                                        for the purpose of the WNBL’s Indigenous Player Classification
                                        </p>`
                                } else {
                                    ev.schema.IndigNBL.Startslot = `<p style="text-align:center;color:lightgreen;font-size:12px;">
                                        <b>Do you give permission for your contact information to be shared with the NBL, Basketball Victoria,
                                        Adelaide 36ers, Brisbane Bullets, Cairns Taipans, Illawarra Hawks, Melbourne United, Perth Wildcats, 
                                        South East Melbourne Phoenix, Sydney Kings, Tasmania JackJumpers, for the purpose of the 
                                        NBL’s Indigenous Player Classification
                                        </p>`
                                }
                            } else {
                                ev.schema.IndigNBL.hidden = true
                                ev.schema.IndigNBL.rules = []
                            }

                        }
                    },
                    Teams: {
                        type: "select",
                        label: "Select Teams you will be Playing for",
                        multiple: true,
                        outlined: true,
                        dense: true,
                        hidden: true,
                        clearable: true,
                        col: 12,
                        rules: [rules.requiredSelSingle],
                        class: 'mx-1 px-1',
                        items: Clubs,
                        Role: 1,
                        Accreditation: settings.PlayerAccred,
                        AccredStart: '',
                        AccredEnd: '',
                        AccredTeam: 3223,
                        returnObject: true,
                        itemText: 'Detail',
                        noDataText: 'Please Enter Association & Competition Selection First',
                        Startslot: `<b>Youth players who are intending on playing in 
                                their Senior Big V association team at some point during 
                                the season please select both so you assigned to both 
                                team rosters.</b></br>`,
                        onInput: async (ev, portal) => {
                            if (ev.data.Teams.find((team) => {
                                return team.Detail.includes("Championship") && !team.Detail.includes("Youth")
                            })) {
                                ev.schema.MatchFixing.hidden = store.getters.integrity
                                ev.schema.MatchFixing.rules = (store.getters.integrity) ? [] : [rules.requiredMsg('Introduction to Match-Fixing Certificate is Required')]
                                ev.schema.haveMatchFixing.hidden = !store.getters.integrity
                            } else {
                                ev.schema.MatchFixing.hidden = true
                                ev.schema.MatchFixing.rules = []
                                ev.schema.haveMatchFixing.hidden = true
                            }
                        },
                        OUG: { Contact_Roles: true, Type: "Teams" }
                    },
                    IndigNBL: {
                        addText: " to Permission to Share Contact Information",
                        type: "select",
                        label: "Permission to Share Contact Information",
                        outlined: true,
                        dense: true,
                        hidden: true,
                        rules: [rules.requiredMsg('Share Contact Information is required')],
                        class: 'mx-1 px-1',
                        items: ["Yes", "No", "Rather Not Say"],
                        value: '',
                        col: 12,
                        Startslot: `<p style="text-align:center;color:lightgreen;font-size:12px;">
                            <b>Do you give permission for your contact information to be shared with the NBL, Adelaide 36ers, 
                            Brisbane Bullets, Cairns Taipans, Illawarra Hawks, Melbourne United, Perth Wildcats, 
                            South East Melbourne Phoenix, Sydney Kings, Tasmania JackJumpers, for the purpose of the 
                            NBL’s Indigenous Player Classification
                        </p>`,
                        OUG: {
                            Contact_Details: {
                                Type: 3369,
                                Action: "SingleDesc",
                                Description: 'Permission to Share Contact Information',
                            }
                        }
                    },
                    MatchFixing: {
                        type: 'file',
                        label: 'BA Integrity Gambling & Match Fixing Certificate',
                        multiple: false,
                        accept: "image/*,application/pdf",
                        outlined: true,
                        hidden: true,
                        dense: true,
                        col: 12,
                        rules: [rules.fileSize()],
                        class: 'mx-1 px-1',
                        Startslot: `This is a MANDATORY requirement for all Championship senior players.</br>
                                            <b>Click below to access and complete the course requirement:</b></br>
                                            <a href="https://basketballaustralia.etrainu.com/training/?event=course.purchase&bundleID=3F0F3FD7-A729-42C2-9F88-41CA9C6B5C97&secret=5E2104A0-BE72-CB0A-62F8BC01C42F51F2" target="blank">BA Integrity Course Registration - Gambling and Match Fixing Course</a> </br>
                                            </br>`,
                        OUG: {
                            Contact_Details: {
                                Type: 1867,
                                Action: "SingleDesc",
                                Description: "BA Integrity Gambling & Match Fixing Certificate",
                            }
                        },
                    },
                    haveMatchFixing: {
                        type: 'text',
                        dense: true,
                        disabled: true,
                        hidden: true,
                        class: 'mx-1 px-1',
                        Startslot: `<H4 style="text-align:center;color:red">We already have a copy of your BA Integrity Gambling & Match Fixing Certificate</H4>`
                    },
                    DOB: {
                        type: 'text',
                        ext: 'date',
                        locale: 'en',
                        // prependIcon: 'event',
                        label: `Date of Birth (${store.getters.getdateFormat})`,
                        outlined: true,
                        dense: true,
                        mask: store.getters.getdateMask,
                        rules: [rules.requiredMsg('Date of Birth is Required'),
                        rules.minAge(`The Big V has a minimum age in all divisions that a player 
                                    must turn at least 14 years of age during
                                    the year in which the player seeks to register. 
                                    You are not eligible to register for this current competition year`, '2011-01-01')],
                        class: 'mx-1 px-1',
                        toCtrl: (ev) => {
                            if (new Date(ev.data.DOB) > new Date('2008-03-17')) {
                                ev.schema.Indeminity.hidden = false
                                ev.schema.Indeminity.rules = [rules.requiredMsg('U16 Signed Indeminity Form is Required')]
                            } else {
                                ev.schema.Indeminity.hidden = true
                                ev.schema.Indeminity.rules = []
                            }
                            return ev.data.DOB
                        },
                        OUG: { Contacts: { Field: "date_of_birth" } }
                    },
                    Indeminity: {
                        type: 'file',
                        label: 'Please upload duly authorised Indeminity Form',
                        multiple: false,
                        accept: "image/*,application/pdf",
                        outlined: true,
                        dense: true,
                        hidden: true,
                        col: 12,
                        rules: [rules.fileSize()],
                        class: 'mx-1 px-1',
                        Startslot: `<b><i>As you are sixteen (16) years of age or younger at the commencement of the season,  
                                            your parent must complete and sign in the presence of the Association delegate, 
                                            an indemnification form provided by the league in recognition that the Big V 
                                            is a senior competition. </i></b><br></br>
                                            
                                            <a href="https://admin.ownurgoal.net.au/_lib/file/doc/2024_BigV_U16_Age_Indemnification Form.pdf" target="blank">
                                            Contact your Association Delegate to complete </a>`,
                        OUG: {
                            Contact_Details: {
                                Type: 1867,
                                Action: "SingleDesc",
                                Description: 'U16 Signed Indeminity Form',
                            }
                        },
                    },
                    GenderAB: {
                        type: "select",
                        label: "Gender At Birth",
                        outlined: true,
                        dense: true,
                        rules: [rules.requiredMsg('Gender At Birth is Required')],
                        class: 'mx-1 px-1',
                        items: ['Male', 'Female'],
                        value: '',
                        OUG: { Contact_Details: { Type: 3723, Action: "Unique" } },
                    },
                    Position: {
                        OUG_id: "346",
                        type: "select",
                        label: "Playing Position",
                        outlined: true,
                        dense: true,
                        rules: [rules.requiredMsg('Position is Required')],
                        class: 'mx-1 px-1',
                        items: settings.PlayerRoles,
                        OUG: { Contact_Details: { Type: 346, Action: "Unique" } },
                    },
                    Height: {
                        id: "353",
                        type: 'number',
                        label: 'Height (cms)',
                        outlined: true,
                        dense: true,
                        rules: [rules.requiredMsg('Height is Required')],
                        class: 'mx-1 px-1',
                        OUG: { Contact_Details: { Type: 353, Action: "Unique" } },
                    },
                },
            },
            // Step 5
            {
                stepno: 5,
                title: 'History',
                valid: true,
                information: `<h3>Playing History</h3></p>
                                This information is required for league information in regards to any clearance requirements required for eligibility for the 2024 Big V season.`,
                Model: {},
                Schema: {
                    DiffAssociation: {
                        OUG_id: "704",
                        addText: "",
                        type: 'select',
                        label: 'Are you registering for a Different Association to last registered for Big V?',
                        hidden: false,
                        outlined: true,
                        dense: true,
                        col: 12,
                        rules: [rules.requiredMsg('Different Association is Required')],
                        class: 'mx-1 px-1',
                        items: [
                            "NO - I played with this same Big V Association the last time I played and will NOT require a clearance",
                            "Yes – The last time I played was for a different Association and I have gained Clearance."
                        ],
                        Startslot: `Were you registered for a different Association, State or International Association? If so, you will need proof of clearance`,
                        OUG: { Contact_Details: { Type: 704, Action: "Unique" } },
                        onInput: async (ev, portal) => {
                            if (ev.data.DiffAssociation == "Yes – The last time I played was for a different Association and I have gained Clearance.") {
                                ev.schema.PrevAssociation.hidden = false
                                ev.schema.PrevAssociation.rules = [rules.requiredMsg('Previous Association is Required')]
                                ev.schema.ProofClearance.hidden = false
                                ev.schema.ProofClearance.rules = [rules.fileSize(), rules.requiredMsg('Proof of Clearance is Required')]
                            } else {
                                ev.schema.PrevAssociation.hidden = true
                                ev.schema.PrevAssociation.rules = []
                                ev.schema.ProofClearance.hidden = true
                                ev.schema.ProofClearance.rules = []
                            }
                        },
                    },
                    PrevAssociation: {
                        id: "1170",
                        type: 'text',
                        label: 'Who was the last association you registered for ?',
                        hidden: true,
                        outlined: true,
                        dense: true,
                        col: 12,
                        rules: [],
                        class: 'mx-1 px-1',
                        Startslot: `Who was the last association you registered for? Please detail the year of registration, 
                                            league and association. </br>
                                            e.g. </br>
                                            1. Year: 2015, League: Big V, Previous association: Whittlesea</br>
                                            2. Year 2020,  League: NBL1Sth, Previous association: Nunawading</br>
                                            3. Year 2021 League: Liga ACB (Spain) Previous Club: Barcelona
                                            `,
                        Endslot: `For your registration to be able to proceed and be submitted to the league for approval you 
                                            are required to upload proof of received clearance approval. <br></br>
                                            <ul>
                                            <li>Your received online clearance approval email notification if you last 
                                            played Big V for a different Big V Association </li></br>
                                            </ul>
                                            <u>or</u> <br></br>
                                            <ul>
                                            <li>Your completed and approved Basketball Australia Clearance Form if you last 
                                            played for another state (e.g. NBL1)</li></br>
                                            </ul>
                                            <u>or</u><br></br>
                                            <ul>
                                            <li>Your approved Basketball Australia  international clearance notification</li></br>
                                            </ul>
                                            
                                            <b>Note - Clearances are not required from VJBL/CBL</b>`,
                        OUG: { Contact_Details: { Type: 1170, Action: "Unique" } },
                    },
                    ProofClearance: {
                        type: 'file',
                        label: 'Please upload received proof notification of clearance approval received',
                        multiple: false,
                        accept: "image/*,application/pdf",
                        outlined: true,
                        dense: true,
                        hidden: true,
                        col: 12,
                        rules: [],
                        class: 'mx-1 px-1',
                        OUG: {
                            Contact_Details: {
                                Type: 1867,
                                Action: "SingleDesc",
                                Description: 'Proof Notification of Clearance',
                            }
                        },
                    },
                    CollegePlayer: {
                        OUG_id: "354",
                        addText: " returning to Australia from playing college basketball",
                        type: 'select',
                        label: 'Are you returning to Australia from playing college basketball?',
                        outlined: true,
                        dense: true,
                        col: 12,
                        rules: [rules.requiredMsg('Returning College Player is Required')],
                        class: 'mx-1 px-1',
                        items: ["Yes", "No"],
                        OUG: { Contact_Details: { Type: 354, Action: "Unique" } },
                        onInput: async (ev, portal) => {
                            if (ev.data.CollegePlayer == "No") {
                                ev.schema.RetCollege.hidden = true
                                ev.schema.RetCollege.rules = []
                            } else {
                                ev.schema.RetCollege.hidden = false;
                                ev.schema.RetCollege.rules = [rules.requiredMsg('Intentions of returing to College is Required')]
                            }
                        },
                    },
                    RetCollege: {
                        addText: "",
                        type: 'select',
                        label: 'Are you intending on going back to college ?',
                        hidden: true,
                        outlined: true,
                        dense: true,
                        col: 12,
                        rules: [],
                        class: 'mx-1 px-1',
                        items: ["Yes - I will be going back to college (e.g currently on a gap year, holidays)",
                            "No – I am fully back in Australia from college and will not be returning and I have gained BA International Clearance approval",
                            "Undecided"],
                        Endslot: `<h4 class="slot">
                                        <b>If you are intending to go back to college, you are not required to submit for a BA International Clearance.
                                        </p>If however you have played Big V before and are intending on playing at a different Big V Association, your Destination Association will be required to submit for a clearance approval from your previous Big V Association.
                                        </b>
                                    </h4>`,
                        onInput: async (ev, portal) => {
                            if (ev.data.RetCollege == "No – I am fully back in Australia from college and will not be returning and I have gained BA International Clearance approval") {
                                ev.schema.IntClearance.hidden = false;
                                ev.schema.IntClearance.rules = [rules.fileSize(), rules.requiredMsg('BA International Clearance is Required')]
                            } else {
                                ev.schema.IntClearance.hidden = true
                                ev.schema.IntClearance.rules = []
                            }
                        },
                        OUG: { Contact_Details: { Type: 354, Action: "SingleDesc" } },
                    },
                    IntClearance: {
                        type: 'file',
                        label: 'Please upload received proof notification of BA International Clearance approval received',
                        multiple: false,
                        outlined: true,
                        dense: true,
                        hidden: true,
                        col: 12,
                        // rules: [rules.requiredMsg('Proof of Clearance is Required')],
                        rules: [],
                        class: 'mx-1 px-1',
                        Startslot: `Because you a returning College Player you are required to provide a BA International Clearance approval`,
                        OUG: {
                            Contact_Details: {
                                Type: 1867,
                                Action: "SingleDesc",
                                Description: 'BA International Clearance Approval',
                            }
                        },
                    },
                },
            },
            // Step 6
            {
                stepno: 6,
                title: 'Confirmation',
                valid: true,
                information: ``,
                // < img src = "https://admin.ownurgoal.net.au/_lib/file/OUGImages/NBL1Uniforms.png" />
                Model: {},
                Schema: {
                    Participate: {
                        addText: "",
                        type: 'checkbox',
                        label: `I have read and agree to the terms and conditions of participation 
                                        in Basketball Victoria's Senior Representative League Big V.`,
                        color: "primary",
                        value: "Agree to all Terms and Conditions for BigV",
                        rules: [rules.requiredMsg('Confirmation and acceptance of Participation Requirements is Required')],
                        class: 'mx-1 px-1',
                        col: 12,
                        Startslot: `<h3>Participation Requirements</h3>`,
                        Endslot: `<a href="https://www.basketballvictoria.com.au/about/about-us/terms" target="blank">
                                        Basketball Victoria Terms and Conditions of Participation</a>`,
                        OUG: { Answer: true }
                    },
                    uniformConfirm: {
                        addText: "",
                        type: 'checkbox',
                        label: `I have read and agree to abide by Basketball Victoria's Compression Garment Policy`,
                        color: "primary",
                        value: "Agree to abide by Compression Garment Policy",
                        rules: [rules.requiredMsg('Confirmation of Compression Garment Policy is Required')],
                        class: 'mx-1 px-1',
                        Startslot: `<h3>Uniform Requirements</h3><br>
                        <a href="https://admin.ownurgoal.net.au/_lib/file/OUGImages/dec17d5d-cf97-4fe8-8697-75f6d011b1df.pdf" target="blank">
                                        Basketball Victoria Leagues Uniform and Undergarment Regulations</a>`,
                        col: 12,
                        OUG: { Answer: true }
                    },
                    foreignPlayer: {
                        addText: "",
                        type: 'checkbox',
                        label: `I agree that if I do not currently have Australian Citizenship, I will gain Basketball Australia approval each competition year so I am eligible to play in any senior elite Big V match.`,
                        color: "primary",
                        value: "Confirm of meet Foreign Player Conditions",
                        rules: [rules.requiredMsg('Confirmation of Foreign Player Requirement is Required')],
                        class: 'mx-1 px-1',
                        col: 12,
                        Startslot: `<h3>Foreign Requirements</h3>`,
                        Endslot: `<a href="https://admin.ownurgoal.net.au/_lib/file/OUGImages/626e43a3-1445-4478-b1a3-c9f6b078beb0.pdf" target="blank">
                                        Basketball Australia Foreign Born Player Policy (non current Australian Citizens)</a>`,
                        OUG: { Answer: true }
                    },
                    cocOperation: {
                        addText: "",
                        type: 'checkbox',
                        label: `I understand and agree to be bound by the Big V Rules of Operation.`,
                        color: "primary",
                        value: "Agree to be bound by BigV Rules of Operation",
                        rules: [rules.requiredMsg('Confirmation of Big V Rules of Operation is Required')],
                        class: 'mx-1 px-1',
                        col: 12,
                        Startslot: `<h3>Big V Rules of Operation Requirements</h3>`,
                        Endslot: `<a href="https://admin.ownurgoal.net.au/_lib/file/OUGImages/0de67f2e-e19b-4598-821d-e44a8cc98335.pdf" target="blank">
                                        2024 Big V Rules of Operation</a>`,
                        OUG: { Answer: true }
                    },
                    cocConfirm: {
                        addText: "",
                        type: 'checkbox',
                        label: `I confirm that I will adhere to the Basketball Victoria Code of Conduct`,
                        color: "primary",
                        value: "Confirm I will adhere to BV Code of Conduct",
                        rules: [rules.requiredMsg('Confirmation of Code of Conduct is Required')],
                        class: 'mx-1 px-1',
                        col: 12,
                        Startslot: `<h3>Code of Conduct Requirements</h3>`,
                        Endslot: `<a href="https://www.basketballvictoria.com.au/resources/association-resources/policies#codes-of-conduct" target="blank">
                                        Basketball Victoria Code of Conduct</a>`,
                        OUG: { Answer: true }
                    },
                    baIntegrityConfirm: {
                        addText: "",
                        type: 'checkbox',
                        label: `I agree to abide by Basketball Australia's National Integrity Framework`,
                        color: "primary",
                        value: "Agree to BA National Integrity Framework",
                        rules: [rules.requiredMsg('Confirmation of BA Integrity Requirements is Required')],
                        class: 'mx-1 px-1',
                        col: 12,
                        Startslot: `<h3>BA Integrity Requirements</h3>`,
                        Endslot: `<a href="https://australia.basketball/integrity/" target="blank">
                                        Basketball Australia National Integrity Framework</a>`,
                        OUG: { Answer: true }
                    },
                    useImages: {
                        addText: "",
                        type: 'checkbox',
                        label: `I acknowledge that BV, Big V and my Club may use images, video, or similar of me for the promotion of the League and the Club.`,
                        color: "primary",
                        value: "Acknowledge use of my Images and Video",
                        rules: [rules.requiredMsg('Use of Images confirmation is Required')],
                        class: 'mx-1 px-1',
                        Startslot: `<h3>Images Requirements</h3>`,
                        col: 12,
                        OUG: { Answer: true }
                    },
                    attendTribunal: {
                        addText: "",
                        type: 'checkbox',
                        label: 'I undertake to attend meetings of the Basketball Victoria Tribunal whenever required to do so and consent to the subsequent reporting of the proceedings of such meetings and hearings.',
                        color: "primary",
                        value: "Agree to attend Tribunal or other meetings",
                        rules: [rules.requiredMsg('Agreement to Attend is Required')],
                        class: 'mx-1 px-1',
                        Startslot: `<h3>Tribunal Requirements</h3>`,
                        col: 12,
                        OUG: { Answer: true }
                    },
                    infoAccurate: {
                        addText: "",
                        type: 'checkbox',
                        label: 'I confirm that I have provided infomation honestly and that it is both true and accurate.',
                        color: "primary",
                        value: "Confirm information all honest and correct",
                        rules: [rules.requiredMsg('Accurate Information confirmation is Required')],
                        class: 'mx-1 px-1',
                        Startslot: `<h3>Information Requirements</h3>`,
                        col: 12,
                        OUG: { Answer: true }
                    },
                },
            },
            // Step 7
            {
                stepno: 7,
                title: 'Finish',
                valid: true,
                information: `Thank you for your submitted registration for the 2024 Big V season.<br></br>
                            Please note this submitted registration is <b>PENDING APPROVAL</b> from the 
                            league and you and your Association Delegate will receive an email notification 
                            once your registration has been reviewed and approved by the league.<br></br>
                            If your registration has not been approved the league will contact your 
                            Association Delegate to inform them of any further requirements to meet 
                            league eligibility approval for the season.<br></br>

                            <b>Please note that if your registration has been submitted during the 
                            season after 4pm on the Friday prior to a weekends round your 
                            registration will NOT be reviewed and/or approved until the following 
                            round as you have missed that weekends round deadline to submit your 
                            registration.</b>
                            <hr><br></br>


                            Please stay up to date with all Big V news and information throughout the season on the <a href="https://www.basketballvictoria.com.au/bigv/home" target="blank">Big V website</a><br></br>
                            Please also note the number of games required to be played per division to qualify for finals
                            <a href="https://admin.ownurgoal.net.au/_lib/file/doc/2024_Finals_Qualification_Requirements.pdf" target="blank">2024 Big V Finals Qualification</a>`,
                Model: {},
                Schema: {}
            }
        ]
    }
}



export default {

    LoadSchema: async (Parameters) => {
        step2 = await Verification.LoadSchema(2)
        step3 = await Base_Details.LoadSchema(3)
        Countries = await functions.GetCountries();
        PlayingStatus = await functions.GetCodeBy({ Type: "NBL1 Playing Status" });
        Associations = await functions.GetCodeBy({ State_Champs: 3223, Type: "Associations" }, true)
        return Load_BIGV_Player_Steps()
    },



}

